import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const FRONTEND_URL = process.env.REACT_APP_BACKEND_URL;

const downloadQr = (user) => {
  const svg = document.querySelector('.qr-modal-content svg');
  if (!svg) return;
  const svgData = new XMLSerializer().serializeToString(svg);
  const canvas = document.createElement('canvas');
  canvas.width = 400; canvas.height = 400;
  const ctx = canvas.getContext('2d');
  const img = new Image();
  img.onload = () => {
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, 400, 400);
    ctx.drawImage(img, 0, 0, 400, 400);
    const a = document.createElement('a');
    a.download = `QR_${user.first_name}_${user.last_name}.png`;
    a.href = canvas.toDataURL('image/png');
    a.click();
  };
  img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
};

export const WorkerQrDialog = ({ user, onClose }) => (
  <Dialog open={!!user} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="bg-white border-[#2B4B8C]/10 max-w-xs text-center" data-testid="qr-modal">
      <DialogHeader>
        <DialogTitle className="text-[#2B4B8C]">QR de Competencias</DialogTitle>
      </DialogHeader>
      {user && (
        <div className="flex flex-col items-center gap-3 py-2">
          <div className="p-3 bg-white rounded-xl border border-[#2B4B8C]/10 qr-modal-content">
            <QRCodeSVG value={`${FRONTEND_URL}/competencias/${user.id}`} size={200} fgColor="#2B4B8C" level="M" />
          </div>
          <div>
            <p className="font-semibold text-[#2B4B8C]">{user.first_name} {user.last_name}</p>
            <p className="text-xs text-[#2B4B8C]/50">{user.rut}</p>
          </div>
          <p className="text-[10px] text-[#2B4B8C]/40">Escanea para ver el expediente de capacitaciones del trabajador</p>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" className="border-[#2B4B8C]/10 text-[#2B4B8C]/70" onClick={() => window.open(`/competencias/${user.id}`, '_blank')} data-testid="open-expediente-btn">
              Ver expediente
            </Button>
            <Button variant="outline" size="sm" className="border-[#2B4B8C]/10 text-[#2B4B8C]/70" onClick={() => downloadQr(user)} data-testid="download-qr-btn">
              Descargar QR
            </Button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
